<template>
  <div>
    <el-dialog
      title="注册账号"
      center
      :visible="true"
      @before-close="onClose"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form ref="form" :model="form" label-width="140px" size="mini">
        <el-form-item label="用户名：" prop="name">
          <el-input
            placeholder="请尽量使用方便大家分辨是谁的名称（比如姓名的中文全称）"
            style="width: 350px"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="通知地址类型：" prop="addressType">
          <el-select
            @change="addressTypeChange"
            style="width: 150px"
            v-model="form.addressType"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableAddressTypes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-tooltip effect="dark" placement="top" style="margin-left: 10px">
            <div slot="content">
              通知地址用于后台给账号推送重要通知，请务必准确填写
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.5em"></i
            ></span>
          </el-tooltip>
          <span v-if="form.addressType == '企业微信'">
            <span class="link-button" @click="openGetUserIdDialog()"
              >点击获取通知地址</span
            >
          </span>
        </el-form-item>
        <el-form-item label="通知地址：" prop="webhook">
          <el-input
            :disabled="form.addressType == '企业微信'"
            v-model="form.address"
            placeholder="请务必准确填写"
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button
          :disabled="form.address.length == 0"
          type="primary"
          @click="submit()"
          style="margin-left: 30px"
          >申请注册</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "RegisterDialog";

export default {
  data() {
    return {
      form: {
        name: "",
        address: "",
        addressType: "",
      },
      requestId: "",
      availableAddressTypes: [],
    };
  },
  components: {},

  async created() {
    // 给requestId赋值
    this.requestId = `admin-request-${util.uuid()}`;
    await this.loadAvailableAddressTypes();
  },

  methods: {
    addressTypeChange() {
      this.form.address = "";
    },
    /**
     * 提交表单
     */
    submit() {
      this.register();
    },

    /**
     * 修改密码
     */
    async register() {
      if (this.form.name.trim().length == 0) {
        this.$message({
          message: "用户名不能为空",
          type: "fail",
        });
        return;
      }
      if (this.form.addressType.trim().length == 0) {
        this.$message({
          message: "请选择通知地址类型",
          type: "fail",
        });
        return;
      }
      if (this.form.address.trim().length == 0) {
        this.$message({
          message: "通知地址不能为空",
          type: "fail",
        });
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(`确认注册账号？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/corpflow/createCorpFlowVoteOfRegisterAdminAccount`,
            this.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
                requestId: this.requestId,
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          duration: 0,
          showClose: true,
          message: "已提交申请，待通过之后可登录后台",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },
    async loadAvailableAddressTypes() {
      this.availableAddressTypes = [];
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpMemberAddressTypes`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.types || [];
      for (let item of listInResponse) {
        this.availableAddressTypes.push(item);
      }
    },
    async openGetUserIdDialog() {
      this.$dialogutil.open("GetUserIdDialog", {
        closedCallback: (param) => {
          if (param != null) {
            this.form.address = param;
          }
        },
        data: { addressType: this.form.addressType, app: "notify" },
      });
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>

<style scoped>
.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>